import PublicationIconV3 from './PublicationIconV3';
import IconsExperiment from './IconsExperiment';
const PublicationIconExperiment = (props) => {
  return <IconsExperiment iconV3={<PublicationIconV3 {...props} />} />;
};

PublicationIconExperiment.displayName = 'PublicationIconExperiment';

export default PublicationIconExperiment;
